import { get, isEmpty } from 'lodash';
import { payeeTypes } from '../../../config';

export const getAddressFormat = (address) => {
	if (isEmpty(address)) {
		return '';
	}
	const { address_line_1, address_line_2, city, postal_code, country } = address;
	return `${address_line_1 && `${address_line_1}, `}${address_line_2 && `${address_line_2}, `}${city && `${city}, `}${
		postal_code && `${postal_code}, `
	}${country && country}`;
};

export const getNewPayeeDetails = ({ addPayeeSuccess }) => {
	const { reference, reference_high_value, display_name, sort_code, account_number, name, type } = addPayeeSuccess;
	if (type === payeeTypes.INTERNATIONAL) {
		const { iban, bic, clearing_code, address, bank } = addPayeeSuccess;

		return {
			name,
			displayName: display_name,
			accountNumber: account_number,
			referenceHighValue: reference_high_value,
			iban,
			bic,
			clearingCode: clearing_code,
			payeeAddress: getAddressFormat(address),
			bankAddress: getAddressFormat(get(bank, 'address', {})),
		};
	}
	if (type === payeeTypes.CHAPS) {
		const { address } = addPayeeSuccess;
		return {
			name,
			displayName: display_name,
			sortCode: sort_code,
			accountNumber: account_number,
			chapsReference: reference_high_value,
			otherPaymentReference: reference,
			payeeAddress: getAddressFormat(address),
		};
	}
	return {
		name,
		displayName: display_name,
		sortCode: sort_code,
		accountNumber: account_number,
		reference,
	};
};
